<template>
    <div class="main-container">
        <div class="main-container-title-box">
            <div class="main-container-title-box-text">
                <span>
                    Деятельность
                </span>
                <v-icon @mouseover="openInfo($event)" @mouseleave="showInfo = false"
                    color="var(--app-dark-blue-1)">mdi-information</v-icon>
            </div>

        </div>

        <v-menu v-model="showInfo" :position-x="x" :position-y="y" absolute offset-y>
            <v-card min-width="300px" min-height="100px">
                <div class="menu-container">
                    <div class="menu-container-title">
                        «Деятельность»
                    </div>
                    <div class="menu-container-text">
                        Список страниц которые можно собрать из блоков в которых собрана различная информация связанная
                        с КСА из которых можно перейти по ссылке, или в файл
                    </div>

                </div>

            </v-card>
        </v-menu>

        <div class="main-container-info-box">

            <div>
                <div class="table-title">
                    Изображение
                    <v-icon @mouseover="openInfoImg($event)" @mouseleave="showInfoImg = false" color="#E0E0E0">
                        mdi-information
                    </v-icon>

                </div>
                <v-menu v-model="showInfoImg" :position-x="xImg" :position-y="yImg" absolute offset-y>
                    <v-card>
                        <div class="menu-container">
                            <div class="menu-container-text">
                                Нажмите на изображение, чтобы увидеть его в полном размере
                            </div>
                        </div>

                    </v-card>
                </v-menu>

            </div>

            <div>
                <v-simple-table v-if="item">
                    <template v-slot:default>
                        <thead>
                            <tr>
                                <th style="padding-left: 24px" class="text-left">
                                    Формат
                                </th>
                                <th class="text-left">
                                    Место отображенния
                                </th>
                                <th class="text-left">
                                    Для смартфонов
                                </th>
                                <th class="text-left">
                                    Для планшетов
                                </th>
                                <th class="text-left">

                                </th>
                            </tr>
                        </thead>
                        <tbody>

                            <tr style="height: 60px;">
                                <td style="padding-left: 24px" class="text-left">Иконка раздела</td>
                                <td class="text-left">Изображение на фоне раздела</td>
                                <td class="text-left">
                                    <img @click="openDialogImg(item.smartphoneImage)" v-if="item.smartphoneImage"
                                        class="table-img" :src="item.smartphoneImage">
                                </td>
                                <td class="text-left">
                                    <img @click="openDialogImg(item.tabletImage)" v-if="item.tabletImage" class="table-img"
                                        :src="item.tabletImage">
                                </td>
                                <td class="text-left" @click="goToEdit">
                                    <v-icon>mdi-pencil-outline</v-icon>
                                </td>
                            </tr>


                        </tbody>
                    </template>
                </v-simple-table>

                <DialogImage v-model="dialogImg" :src="previewImage" />
                <v-divider></v-divider>
            </div>


        </div>
        <div class="main-container">
            <div class="main-container-title-box" style="margin-bottom: 20px">
                <div class="table-title">
                    <span>
                        Список папок
                    </span>
                </div>
                <v-btn @click="goToCreate" style="width: auto !important" class=" button-accept">
                    + Добавить папку
                </v-btn>


            </div>
            <div class="table-container">


                <v-data-table :headers="tableHeaders" :items="folders" item-key="id" :show-select="false"
                    :disable-pagination="true" :hide-default-footer="true">

                    <template v-slot:body="props">
                        <draggable :list="props.items" tag="tbody" @end="endDrag" :move="checkMove"
                            :style="moveItems ? 'pointer-events: none;' : ''">
                            <tr v-for="(item, index) in props.items" :key="index" @click="goToDetail(item)">
                                <td>
                                    <v-icon small style="cursor: pointer; margin-left: 8px"
                                        :disabled="moveItems ? true : false">
                                        mdi-menu
                                    </v-icon>
                                </td>
                                <td> {{ index + 1 }} </td>
                                <td>
                                    {{ item.name }}
                                </td>





                            </tr>
                        </draggable>
                    </template>

                </v-data-table>


            </div>
            <v-divider></v-divider>
        </div>


    </div>
</template>
<script>

import draggable from "vuedraggable";
export default {
    components: {
        draggable
    },
    data: () => ({
        showInfo: false,
        x: null,
        y: null,
        item: {},
        dialogImg: false,
        previewImage: null,
        imageWidth: 0,
        showInfoImg: false,
        moveItems: false,
        selectedDrag: '',
        xImg: null,
        yImg: null,
        blocks: [],
        folders: [],
        tableHeaders: [
            {
                text: '',
                sortable: false
            },
            {
                text: 'Порядок отображения',
                value: '',
                sortable: false
            },

            {
                text: 'Название',
                sortable: false,
                value: 'title',
            },



        ],
        newIndexList: [],

    }),
    methods: {
        openInfo(e) {

            e.preventDefault()

            this.x = e.clientX + 10
            this.y = e.clientY + 10
            this.showInfo = true
        },
        openInfoImg(e) {
            e.preventDefault()
            this.xImg = e.clientX + 10
            this.yImg = e.clientY + 10
            this.showInfoImg = true

        },
        openDialogImg(src) {
            this.previewImage = src
            this.dialogImg = true
        },
        goToEdit() {
            this.$router.push({ name: 'EditActivityImage', params: { key: 'other' } })

        },
        goToCreate() {
            this.$router.push({ name: 'CreateFolderOther' })

        },
        goToDetail(item) {
            this.$router.push({ name: 'DetailFolderOther', params: { id: item.id } })
        },

        getActivity() {
            this.$axios.get(this.$store.getters.apiAdminPanelV2 + '/activity', {
                headers: {
                    'authorization': this.$store.getters.adminPanelHeaderAuth
                },
                params: {
                    key: 'other'
                }
            })
                .then(res => {
                    this.item = res.data

                })
                .catch(err => {
                    this.$store.commit('errorSet', true)
                    this.$store.commit('errorTextSet', err)
                })

        },

        getFolders() {
            this.$axios.post(this.$store.getters.apiAdminPanelV2 + '/activity/other/folder/list', {
            }, {
                headers: {
                    'authorization': this.$store.getters.adminPanelHeaderAuth
                }
            })
                .then(res => {

                    this.folders = res.data.items

                })
                .catch(err => {
                    this.$store.commit('errorSet', true)
                    this.$store.commit('errorTextSet', err)
                })
        },
        endDrag(evt) {

            this.moveItems = true
            this.$axios.put(this.$store.getters.apiAdminPanelV2 + '/activity/other/folder/sort', {
                folderId: this.selectedDrag,
                index: evt.newIndex + 1

            }, {
                headers: {
                    'authorization': this.$store.getters.adminPanelHeaderAuth
                }
            })
                .then(() => {
                    this.getFolders()
                    this.moveItems = false


                })
                .catch(err => {
                    this.$store.commit('errorSet', true)
                    this.$store.commit('errorTextSet', err)
                })

        },
        checkMove(evt) {
            this.selectedDrag = evt.draggedContext.element.id
        },


    },
    created() {
        this.getActivity()
        this.getFolders()
    },
}
</script>
<style lang="scss" scoped>
.main-container {

    .main-container-title-box {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 40px 24px;

        .main-container-title-box-text {
            display: flex;
            align-items: center;

            span {
                font-size: 28px;
                font-weight: 400;
                margin-right: 20px;
            }

        }

    }

    .main-container-info-box {
        .table-title {
            font-size: 24px;
            font-weight: 600;
            margin: 0 24px;
        }

        .info-block {
            width: 50%;
            margin-bottom: 50px;

            .info-block-title {
                font-size: 24px;
                font-weight: 600;
            }

            .info-block-text {
                font-size: 18px;
                font-weight: 400;
            }
        }

        .table-img {
            cursor: pointer;
            height: 38px;
            object-fit: contain;
        }


    }
}

.table-title {
    font-size: 24px;
    font-weight: 600;
}
</style>